import { useState } from "react"
// import IMGBG1 from "../../assets/images/core/arouse/arouseBg.png";
// import IMG3 from "../../assets/images/core/arouse/att_img3.png";
// import IMG2 from "../../assets/images/core/arouse/att_img2.png";
// import IMG9 from "../../assets/images/core/arouse/att_img9.png";
// import CS01 from "../../assets/images/core/arouse/cs_img01.png";
// import CS02 from "../../assets/images/core/arouse/cs_img02.png";
// import IMGFeature1 from "../../assets/images/core/attract/feature1.png";
// import moment from "moment"

// const dst = moment().hour(11).minute(0).second(0)
// const det = moment().hour(15).minute(0).second(0)

export const ArrouseState = () => {
  const [templates, setTemplates] = useState({ view: { toggled: false } })
  const [arouse, setArouse] = useState({ list: null, current: { value: null, stat: false }, action: { selected: null, modal: false, type: 0, confirmed: false } })
  const [lpage, setLpage] = useState({ list: null, action: { modal: false, } })
  const [btnprops, setBtnProps] = useState("hop")
  const [webform, setWebform] = useState({ 
    inputs: { 
            method: 'create',
            websites: null,
            name: {value: 'Website Template',},
            header_properties:{
                data: [
                    {name: 'Home', status: 'yes'},
                    {name: 'Attractions', status: 'yes'},
                    {name: 'Rates', status: 'yes'},
                    {name: 'Promos', status: 'yes'},
                    {name: 'Camping Sites', status: 'yes'},
                    {name: 'Contact Us', status: 'yes'}
                ],        
                logo: { value:  'https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/TanayLogo.png' },
                text_color: { value:  '#000000' },
            },
            home_properties:{
                background_image: { value: "https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/TanayLogo.png"},
                title:  { value: "Discover the Charm of laiban"},
                text:   { value: "Discover the Charm of laiban"},
                text_color: {value: "text_color"},
                contact_us_button: {
                label:   { value: 'contact_us'},
                link: { value: "basta link"},
                text_color:{ value: "#000000"}, 
                background_color:{ value: "#000000"},
                },
                promo_button:   
                {  
                label:{ value: 'contact_us'},
                link: { value: "basta link"},
                text_color:  { value: "#000000"},
                background_color:{ value: "#000000"}
                },            
    
            },
            amenities_properties: {
                title: { value: "Amenities"},
                background_color: { value: "#000000"},
                text_color:{ value: "#000000"},     
                amenities_data:[
                    {
                        name:"Laiban Falls",
                        description:"The falls are situated deep",
                        featured_image:"https://marketing-system-repo.s3.amazonaws.com/mt/phases/1685954168783.jpg"
                    },
                    {
                        name: "Mt. Ngusong kabayo",
                        description: "Mt. ngusong kabayo also known as Ngushi hahaha",
                        featured_image:"https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/TourPackages.png"
                    },
                    
                    ],   
                button: [    
                    { label:"View Promo"},        
                    {link:"basta link to" },
                    {text_color:"#000000"},
                    {background_color:"#000000"}        
                    ],
            },
        
        rates_properties:{
            background_color: { value: "#000000"},
            entrance:
            [
                { name: "Day Tour", regular_rate: '200'},
                { name: "Overnight Tour - 2PAX", regular_rate: '300'},
                { name:"Kids (5 years old and below) ", regular_rate: '150'},  
            ] ,
          
            tent:
            [
                { name: "Tent", regular_rate: '200'},
                { name: "Tent for Rent - 2PAX", regular_rate: '350'},
                { name:"Tent for rent - 4PAX", regular_rate: '550'},  
            ] ,
            cottage:
            [
                { name: "Open Kubo for 15-20PAX'", regular_rate: '3500'},                
            ] ,
            text:   { value: "Discover the Charm of laiban"},
            text_color: {value: "text_color"},
            contact_us_button: {
            label:   { value: 'contact_us'},
            link: { value: "basta link"},
            text_color:{ value: "#000000"}, 
            background_color:{ value: "#000000"},
            },
            promo_button:   
            {  
            label:{ value: 'contact_us'},
            link: { value: "basta link"},
            text_color:  { value: "#000000"},
            background_color:{ value: "#000000"}
            },            

        },
        
            promos_properties: [{promos: ["2", "3", "4",]}, 
                {button: [{label: "View Promo"}, {link: "kahit ano"}, {text_color:"#000000"} , {background_color:"#000000"}]} 
        ],    
            camping_sites_properties: [
                {background_color:"#000000" },
                {camping_sites: [{name: "Mira Agro Park"}, {featured_image: "https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/CSiteImage.png"},
                {featured_image: "https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/Mbackground.png"}] },
                {featured_image: "https://hrc-static.s3.ap-southeast-1.amazonaws.com/HRC/default/Promopic.png"} 
        ], 
            contact_us_properties:[
                {background_color: "#000000"}, {text_color: "#000000"}, {reservation_mobile: "#000000"}
        ]
        
    },

})

  return {
    templates: { data: templates, set: setTemplates },
    lpage: { data: lpage, set: setLpage },
    btnprops: { data: btnprops, set: setBtnProps },
    // arform: { data: arform, set: setARForm },
    arouse: { data: arouse, set: setArouse },
    webform: {data: webform, set: setWebform},
  }
}






